import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Subject_Area_Search_Fields: {[id:string]: ISearchProviderField} = {
    WB_SUBJECTAREA_ID:          {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Subject Area Id',         columnResourceName: 'colId',              alignment: HorizAlignment.Left},  domainOptions: {}},
    SUBJECT_AREA_ID:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Subject Area Id',            columnResourceName: 'colId',              alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SUBJECT_AREA_NAME:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Subject Area Name',          columnResourceName: 'colAreaName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SOURCE_NAME:                {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Source Name',                columnResourceName: 'colSrcName',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    GENERATE_IND:               {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Generate Ind',               columnResourceName: 'colGenerateInd',     alignment: HorizAlignment.Left},  domainOptions: {}},
    ENABLED_IND:                {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Enabled Ind',                columnResourceName: 'colEnabledInd',      alignment: HorizAlignment.Left},  domainOptions: {}},
    CUSTOMER_IND:               {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Customer Ind',               columnResourceName: 'colCustomerInd',     alignment: HorizAlignment.Left},  domainOptions: {}},
    CUSTOMER_REL_IND:           {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Customer Relationship Ind',  columnResourceName: 'colCustRelInd',      alignment: HorizAlignment.Left},  domainOptions: {}},
    CUSTOMER_SRC_IND:           {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Customer Source Ind',        columnResourceName: 'colCustSrcInd',      alignment: HorizAlignment.Left},  domainOptions: {}},
    SUPPLYDIRECTION_IND:        {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Supply Direction Ind',       columnResourceName: 'colSuppDirInd',      alignment: HorizAlignment.Left},  domainOptions: {}},
    PRODUCTGROUP_IND:           {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Product Group Ind',          columnResourceName: 'colProdGrpInd',      alignment: HorizAlignment.Left},  domainOptions: {}},
    PERIOD_IND:                 {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Period Ind',                 columnResourceName: 'colPeriodInd',       alignment: HorizAlignment.Left},  domainOptions: {}},
    PLAN_HIER_IND:              {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Plan Hierarchy Ind',         columnResourceName: 'colPlanHierInd',     alignment: HorizAlignment.Left},  domainOptions: {}},
    SNAPSHOT_IND:               {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Snapshot Ind',               columnResourceName: 'colSnapshotInd',     alignment: HorizAlignment.Left},  domainOptions: {}},
    GLACCOUNT_IND:              {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'GLAccount Ind',              columnResourceName: 'colGLAcctInd',       alignment: HorizAlignment.Left},  domainOptions: {}},
    EVENT_TYPE_IND:             {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Event Type Ind',             columnResourceName: 'colEvtTypeInd',      alignment: HorizAlignment.Left},  domainOptions: {}},
    EVENT_SPEND_TYPE_IND:       {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Event Spend Type Ind',       columnResourceName: 'colEvtSpndTypeInd',  alignment: HorizAlignment.Left},  domainOptions: {}},
    FUND_TYPE_IND:              {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Fund Type Ind',              columnResourceName: 'colFundTypeInd',     alignment: HorizAlignment.Left},  domainOptions: {}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const SubjectAreaSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_SUBJECTAREA_ID',
                id_ui: 'SUBJECT_AREA_ID',
                name: 'SUBJECT_AREA_NAME'
    },

    searchProviderFields: vUI_Subject_Area_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Subject_Area_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const SubjectAreaSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "SubjectAreaSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'SUBJECT_AREA_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'SUBJECT_AREA_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'SUBJECT_AREA_ID', 'SUBJECT_AREA_NAME', 'SOURCE_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SubjectAreaSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SubjectAreaSearch: ISearch = {
    searchName: "Find Subject Area",
    renderOptions: {ui5ResourceId: "SubjectAreaSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SubjectAreaSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("SubjectAreaBO", "SubjectArea", SubjectAreaSearch, "Subject Area Search")

export {SubjectAreaSearch}